export enum ReviewType {
  Movie = 0,
  Show = 1,
  Look = 2,
}
